var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Home-swiper'),(_vm.isSlideBar)?_c('SlideBar',{attrs:{"gameData":_vm.gameData}}):_vm._e(),_c('Map',{ref:"maps"}),_c('Hero'),_c('Corps'),_c('BattleFiled',{ref:"battles"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }